import type { AppearanceDto } from '@bldsoft/cappie/api/wbs'
import type {
  AppearanceModulesSet,
  AppearanceStylesSet,
} from '@setplex/tria-api'
import type { ApiType } from '../../../shared/schemas'

import * as v from 'valibot'
import { ModulesSchema } from './modules'
import { FALLBACK_STYLE, StyleSchema } from './styles'

export const AppearanceSchemaStyles = v.object({
  mainStyle: v.nullish(StyleSchema, FALLBACK_STYLE),
  additionalStyle: v.nullish(StyleSchema, FALLBACK_STYLE),
  backgroundStyle: v.nullish(StyleSchema, FALLBACK_STYLE),
  secondaryStyle: v.nullish(StyleSchema, FALLBACK_STYLE),
}) satisfies ApiType<Partial<AppearanceDto>, AppearanceStylesSet>

export const AppearanceSchema = v.object({
  ...AppearanceSchemaStyles.entries,
  modules: v.nullish(ModulesSchema, undefined) as any,
}) satisfies ApiType<Partial<AppearanceDto>, AppearanceModulesSet>
